module.exports = __webpack_public_path__ + "img/LANDUSEPLANNING-SavannahChappus.0d879d38.svg";